import { LayoutComponent, ControlsToggleExtraContent } from "@jelly/lesson";
import config from "appConfig";

export const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: { block: { type: "image", options: { src: `${config.ASSETS_URL}/01/16/principle/db-spl-kr-1.png` } } },
  },
];

export const extraContent: ControlsToggleExtraContent = [{ type: "badge", options: { items: ["R = 1.09 cm"] } }];

export default components;
